import { BaseElement } from 'base';

class AffiliateStickyCta extends BaseElement {
  onConnect() {
    this.ticking = false;
    this.listen(window, 'scroll', this.onScroll, { passive: true });
    this.listen(window, 'resize', this.onScroll, { passive: true });
    this.sync();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.sync();
    });
  }

  sync() {
    if (!this.isConnected) return;
    this.setAttribute(
      'data-visible',
      window.scrollY >= window.innerHeight ? 'true' : 'false'
    );
  }
}

if (!customElements.get('affiliate-sticky-cta')) {
  customElements.define('affiliate-sticky-cta', AffiliateStickyCta);
}
